module.exports = __webpack_public_path__ + "img/k-bg1.88bb4d13.png";